import { useEffect, useState } from 'react';

import { MsalProvider } from '@azure/msal-react';

import Sidebar from 'common/Sidebar';
import AuthProvider from 'providers/AuthProvider';
import ToastProvider from 'providers/ToastProvider';
import UnsavedProvider from 'providers/UnsavedProvider';
import Routes from 'Routes';
import { getMsalInstance, initializeMsalInstance } from 'auth/msalInstance';

/**
 * Component
 */
function App() {
  /**
   * State
   */
  const [isInitialized, setIsInitialized] = useState(false);

  /**
   * Effects
   */
  // 🟡 Effect - Initialize MSAL before rendering the app
  useEffect(() => {
    initializeMsalInstance()
      .then(() => setIsInitialized(true))
      .catch((error) => {
        console.error('MSAL initialization failed:', error);
        setIsInitialized(true);
      });
  }, []);

  /**
   * Render
   */
  if (!isInitialized) {
    return null;
  }

  return (
    <MsalProvider instance={getMsalInstance()}>
      <ToastProvider>
        <AuthProvider>
          <UnsavedProvider>
            <Sidebar>
              <Routes />
            </Sidebar>
          </UnsavedProvider>
        </AuthProvider>
      </ToastProvider>
    </MsalProvider>
  );
}
export default App;
